export const LIST_SHIFT_REQUEST = 'LIST_SHIFT_REQUEST'
export const LIST_SHIFT_SUCCESS = 'LIST_SHIFT_SUCCESS'
export const LIST_SHIFT_FAIL = 'LIST_SHIFT_FAIL'

export const LIST_SHIFT_SUMMARY_REQUEST = 'LIST_SHIFT_SUMMARY_REQUEST'
export const LIST_SHIFT_SUMMARY_SUCCESS = 'LIST_SHIFT_SUMMARY_SUCCESS'
export const LIST_SHIFT_SUMMARY_FAIL = 'LIST_SHIFT_SUMMARY_FAIL'

export const CREATE_SHIFT_REQUEST = 'CREATE_SHIFT_REQUEST'
export const CREATE_SHIFT_SUCCESS = 'CREATE_SHIFT_SUCCESS'
export const CREATE_SHIFT_FAIL = 'CREATE_SHIFT_FAIL'

export const DETAIL_SHIFT_REQUEST = 'DETAIL_SHIFT_REQUEST'
export const DETAIL_SHIFT_SUCCESS = 'DETAIL_SHIFT_SUCCESS'
export const DETAIL_SHIFT_FAIL = 'DETAIL_SHIFT_FAIL'

export const UPDATE_SHIFT_REQUEST = 'UPDATE_SHIFT_REQUEST'
export const UPDATE_SHIFT_SUCCESS = 'UPDATE_SHIFT_SUCCESS'
export const UPDATE_SHIFT_FAIL = 'UPDATE_SHIFT_FAIL'

export const DELETE_SHIFT_REQUEST = 'DELETE_SHIFT_REQUEST'
export const DELETE_SHIFT_SUCCESS = 'DELETE_SHIFT_SUCCESS'
export const DELETE_SHIFT_FAIL = 'DELETE_SHIFT_FAIL'

export const RESET_SHIFT = 'RESET_SHIFT'